function cleanCompanyName(string) {
  return string.trim()
    .replace(/ co ltd$/i, "").trim()
    .replace(/ co. ltd.$/i, "").trim()
    .replace(/ co. ltd$/i, "").trim()
    .replace(/ co inc$/i, "").trim()
    .replace(/ co. inc.$/i, "").trim()
    .replace(/ co., inc.$/i, "").trim()
    .replace(/ co.$/i, "").trim()
    .replace(/ co$/i, "").trim()
    .replace(/ltd./i, "").trim()
    .replace(/ltd$/i, "").trim()
    .replace(/inc.$/i, "").trim()
    .replace(/inc$/i, "").trim()
    .replace(/ llc$/i, "").trim()
    .replace(/ corp.$/i, "").trim()
    .replace(/ corp$/i, "").trim()
    .replace(/,$/i, "").trim()
}
export default cleanCompanyName;